import { ExclamationCircleIcon } from "@heroicons/react/24/outline";
import { Alert, Button, Label, Modal } from "flowbite-react"

interface IEnvioErroDevolucaoEmMassaModalProps {
  onClose: () => void
  isOpen: boolean
}

const EnvioErroDevolucaoEmMassaModal: React.FC<IEnvioErroDevolucaoEmMassaModalProps> = ({
  onClose,
  isOpen,
}) => {
  return (
    <Modal show={isOpen} size="xl" onClose={onClose}>
      <Modal.Body>
        <div className='mb-5 text-center'>
          <Alert color={'yellow'} className='flex items-center'>
            <div className='flex flex-col justify-center items-center gap-2 mb-4'>
              <ExclamationCircleIcon className='md:w-8 md:h-8 w-12 h-12 text-yellow-700' />
              <span className='block text-center text-xl font-semibold'>
                Importação em andamento
              </span>
              <Label className='block mt-4 text-gray-600 leading-7 text-center'>
                Já existe uma importação ativa para algum CNPJ da empresa. Aguarde a finalização antes de iniciar uma nova. 
                Você pode acompanhar o status pelo menu <strong>Registro de Devoluções</strong>.
              </Label>
            </div>
          </Alert>
        </div>
        <div className='flex gap-2 justify-center items-center'>
          <Button
            onClick={onClose}
            color='gray'
          >Fechar</Button>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default EnvioErroDevolucaoEmMassaModal
